import React, { ReactElement, Component, useState, useEffect, useContext, Fragment, useMemo } from "react";
import { Select, Row, Col } from "antd";
import "./dropdown-menu-subscription.less";
import { UserSubscriptionsContext, user_subscription } from "../../contexts/user-subscriptions";
import { IUserInfoType, UserInfoContext } from "../../contexts/user-info";
import Cookies from "universal-cookie";
import { withRouter } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { TypeNameContext } from "../../contexts/type_name";
import {
    http_get,
    loading_alert_before,
    loading_alert_after,
    get_domain
} from "../../pages/service/common-file/service";
//   import {UserMeContext} from '../../pages/service/contexts/user-me';
import { subscriptionType } from '../../pages/service/common-file/interfaceType';
import { SubscriptionSelectedContext } from '../../pages/service/contexts/subscription-selected';

const cookies = new Cookies();

const unique = (arr: any) => {
    if (Array.isArray(arr)) {
        var arr1 = [];       // 新建一个数组来存放arr中的值
        for (var i = 0, len = arr.length; i < len; i++) {
            if (arr1.indexOf(arr[i]) === -1) {
                arr1.push(arr[i]);
            }
        }
        return arr1;
    } else {
        return [];
    }
};

const DropdownMenuSubscription: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const [user_subscriptions, set_user_subscriptions]: [
        user_subscription[] | undefined,
        React.Dispatch<React.SetStateAction<user_subscription[] | undefined>>
    ] = useContext(UserSubscriptionsContext),
        [user_info, set_user_info]: [IUserInfoType, React.Dispatch<React.SetStateAction<IUserInfoType>>] = useContext(UserInfoContext),
        // clusters_for_page: clusters_for_page_type | undefined = useContext(ClustersForPageContext)[0],
        type_name: string | undefined = useContext(TypeNameContext)[0],
        [subscription_selected, set_subscription_selected]: [subscriptionType, React.Dispatch<React.SetStateAction<subscriptionType>>] = useContext(SubscriptionSelectedContext),
        // service 
        // [user_me, set_user_me]: [any, React.Dispatch<React.SetStateAction<any>>] = useContext(UserMeContext),
        [subscription, set_subscription]: [any, React.Dispatch<React.SetStateAction<any>>] = useState([]),
        [mp_service_subscription, set_mp_service_subscription]: [any, React.Dispatch<React.SetStateAction<any>>] = useState([]),

        service_pathname: string[] = ['/monitor/service-usage', '/instance-list', '/create-secret', '/resource/view', '/resource/service'],
        subscription_option_all = [{
            key: 'all',
            subscriptionId: 'all',
            subscriptionName: 'all',
            company: 'all'
        }],
        pathname_subscription: any = {
            '/instance-list': true,
            //   '/': true,
            //   '/resource-management/overview': true,
            //   '/create-secret': true,
            //   '/resource-management/service-management': true
        },

        path = useMemo(() => props.history.location.pathname, [props]),
        is_not_login = useMemo(() => !path.includes("/login/"), [path]),
        { formatMessage } = useMemo(() => props.intl, [props]),
        { Option } = useMemo(() => Select, []);

    useEffect(() => {
        if (path.includes("applications")) {
            const subscription_session1 = new Cookies().get("subscription_id");
            if (user_info.ssoRole === "globalAdmin") {
                (async() => {
                    loading_alert_before();
                    const { data } = await http_get(`/v4.0/subscriptions?maxResults=9999&page=&direction=&property=`, props) as any || {};
                        if (data?.resources) {
                            const { resources } = data;
                            const app_aubscription_new: user_subscription[] = [];
                            resources.map((item: any) => {
                               return app_aubscription_new.push({
                                    subscriptionId: item.id,
                                    subscriptionName: item.name,
                                    company: item.company,
                                    subscriptionRole: 'string',
                                    clusterType: 'string',
                                })
                            });
                            const subscription_id: string | undefined = (
                                app_aubscription_new?.find(({ subscriptionId }: user_subscription): boolean => subscriptionId === subscription_session1) ||
                                (app_aubscription_new || [])[0]
                            )?.subscriptionId;
                            set_user_subscriptions(app_aubscription_new);
                            cookies.set("subscription_id", subscription_id, get_domain());
                            set_user_info((currentState) => ({
                                ...currentState,
                                subscription_id,
                            }));
                        }
                    loading_alert_after();
                })()
            } else {
                if (user_info?.ssoSubscriptions && user_info?.ssoSubscriptions?.length > 0) {
                    const userSubscriptions_new1 = user_info?.ssoSubscriptions?.sort((a: user_subscription, b: user_subscription) =>
                        a.subscriptionName.toLocaleLowerCase().localeCompare(b.subscriptionName.toLocaleLowerCase())
                    ),
                        subscription_id: string | undefined = (
                            userSubscriptions_new1?.find(({ subscriptionId }: user_subscription): boolean => subscriptionId === subscription_session1) ||
                            (userSubscriptions_new1 || [])[0]
                        )?.subscriptionId;
                    set_user_subscriptions(userSubscriptions_new1);
                    cookies.set("subscription_id", subscription_id, get_domain());
                    set_user_info((currentState) => ({
                        ...currentState,
                        subscription_id,
                    }));
                } else {
                    set_user_subscriptions([]);
                }
            }
        }
        // eslint-disable-next-line
    }, [path, user_info?.ssoSubscriptions, user_info?.subscription_id])

    useEffect(() => {
        if ((path.includes("clusters") || path.includes("cluster-info/overview")) && user_info?.userSubscriptions) {
            const filter_subscriptions = (type__name: string) => {
                const list1: any = [];
                for ( let item of user_info?.roles ) {
                    if (item.roleName !== "workspaceOwner" && item.roleName !== "namespaceDeveloper" && item.clusterType === type__name) {
                        list1.push(...user_info?.userSubscriptions.filter((each: user_subscription) => each.subscriptionId === item.subscriptionId))
                    }
                }
                return unique(list1);
            }
            type_name === "dedicate" ? set_user_subscriptions(filter_subscriptions("dedicate")) : set_user_subscriptions(filter_subscriptions("shared"));
        }
        // eslint-disable-next-line
    }, [path, user_info?.userSubscriptions, user_info?.roles, type_name]);


    useEffect(() => {
        if (service_pathname.includes(path)) {
            if (!(subscription?.length > 0)) {
                if (user_info.ssoRole === "globalAdmin") {
                    (async () => {
                        loading_alert_before();
                        // const userMe: any = await http_get('v4.0/users/me', props);
                        // userMe&&userMe.data&&set_user_me(userMe.data);
                        const { data } = await http_get(`/v4.0/subscriptions?maxResults=9999&page=&direction=&property=`, props) as any || {};
                        if (data?.resources) {
                            const { resources } = data;
                            if (resources.length > 0) {
                                const new_list: any = path.includes("instance-list") ? [{
                                    // key: 'all',
                                    subscriptionId: 'all',
                                    subscriptionName: 'all',
                                    company: 'all'
                                }] : [],
                                    local_subscription: any = JSON.parse(localStorage.getItem('service_subscription_selected') || '{}'),
                                    cookie_subscription: string | null = cookies.get('service_subscription_id'),
                                    storage_subscription_id: string | null | undefined = cookie_subscription || local_subscription.subscriptionId;
                                let selected_subscription: boolean = true;
                                // eslint-disable-next-line
                                resources.map((item: any, key: number) => {
                                    new_list.push({
                                        // key: key,
                                        subscriptionId: item.id,
                                        subscriptionName: item.name,
                                        company: item.company
                                    });
                                    if (storage_subscription_id === item.id) {
                                        set_subscription_selected({
                                            // key: key,
                                            subscriptionId: item.id,
                                            subscriptionName: item.name,
                                            company: item.company
                                        });
                                        localStorage.setItem('service_subscription_selected', JSON.stringify({
                                            // key: key,
                                            subscriptionId: item.id,
                                            subscriptionName: item.name,
                                            company: item.company
                                        }));
                                        cookies.set('service_subscription_id', item.id, get_domain());
                                        selected_subscription = false;
                                    }
                                });
                                if (selected_subscription) {
                                    const bool: boolean = user_info.ssoRole === 'globalAdmin' && pathname_subscription[path];
                                    // const bool: boolean = user_info.is_globaladmin ? true : false;
                                    set_subscription_selected(bool ? subscription_option_all : new_list[0]);
                                    cookies.set('service_subscription_id', bool ? 'all' : new_list[0].subscriptionId, get_domain());
                                };
                                set_subscription(new_list);
                            }
                        }
                        loading_alert_after()
                    })()
                } else {
                    set_subscription(user_info.ssoSubscriptions ||[]);
                    // set_subscription_selected(user_info.ssoSubscriptions?.[0]);
                    // cookies.set('service_subscription_id', user_info.ssoSubscriptions?.[0].subscriptionId, get_domain());
                }
            }
        }
        // eslint-disable-next-line
    }, [path, subscription, user_info.ssoRole, user_info?.ssoSubscriptions]);

    useEffect(() => {
        if (service_pathname.includes(path)) {
            if (path.includes("monitor/service-usage")) {
                if (mp_service_subscription && mp_service_subscription.length > 0) {   
                    const cookie_subscription: string | undefined = cookies.get('service_subscription_id');
                    if (!cookie_subscription || cookie_subscription) {
                        set_subscription_selected((cookie_subscription && mp_service_subscription.find((each: any) => each.subscriptionId === cookie_subscription)) || mp_service_subscription[0]);
                    }
                } else {
                    set_subscription_selected({});
                }  
            } else {
                if (subscription && subscription.length > 0) {
                    const cookie_subscription: string | undefined = cookies.get('service_subscription_id');
                    if (!cookie_subscription || cookie_subscription) {
                        set_subscription_selected((cookie_subscription && subscription.find((each: any) => each.subscriptionId === cookie_subscription)) || subscription[0]);
                    }
                } else {
                    set_subscription_selected({});
                }
            }
        }
        // eslint-disable-next-line
    }, [subscription, mp_service_subscription, path]);

    useEffect(() => {
        if (service_pathname.includes(path) && path === "/monitor/service-usage" && user_subscriptions && subscription) {
            let new_subscription: any = [];
            const subscription_new = JSON.parse(JSON.stringify(subscription));
            subscription_new.map((each: user_subscription) => {
                new_subscription.push({
                    company: each.company,
                    subscriptionId: each.subscriptionId,
                    subscriptionName: each.subscriptionName,
                })
                return new_subscription;
            });

            const user_subscriptions_new = JSON.parse(JSON.stringify(user_subscriptions));

            for (let item of user_subscriptions_new) {
                const arr = subscription_new?.find((each: any) => each.subscriptionId === item.subscriptionId);
                if (!arr) {
                    new_subscription.push(item)
                }
            }
            set_mp_service_subscription(new_subscription);
        }
        // eslint-disable-next-line
    }, [user_subscriptions, subscription, path]);

    return (
        <Fragment>
            <div className={`${(path.includes('console') || path.includes('overview') || (path.includes("monitor") && !path.includes("monitor/service-usage"))) ? 'd-flex' : ''}`}>
                <div className={`${(path.includes('console') || path.includes('overview') || (path.includes("monitor") && !path.includes("monitor/service-usage"))) ? 'line-height-32 min-width-142' : ''} ${path.includes('service-usage') ? 'select-label' : ''} font_size_14`}>
                    <FormattedMessage id="subscription_name" />
                    {(path.includes('console') || path.includes('overview') || (path.includes("monitor") && !path.includes("monitor/service-usage"))) && <span className="pr-20">: </span>}
                </div>
                {service_pathname.includes(path) && ((path.includes("instance-list") && subscription) || (path.includes("monitor/service-usage") && mp_service_subscription)) && <Select
                    className={`${!path.includes('console') && !path.includes('instance-list') ? 'height-40' : ''} w-100`}
                    showSearch
                    value={path.includes("monitor/service-usage") ? (subscription_selected?.subscriptionId ? subscription_selected?.subscriptionId : mp_service_subscription[0]?.subscriptionId) : (subscription_selected?.subscriptionId && subscription.find((each: any) => each.subscriptionId === subscription_selected?.subscriptionId) ? subscription_selected?.subscriptionId : subscription[0]?.subscriptionId)}
                    optionFilterProp="children"
                    dropdownRender={(menu) => (
                        <Fragment>
                            <div className="ant-select-item ant-select-item-group">With Resources Only</div>
                            {menu}
                        </Fragment>
                    )}
                    filterOption={(input, option) => {
                        return (option?.key as string)?.toLocaleLowerCase().includes(input.toLocaleLowerCase())
                    }}
                    onChange={(event: string) => {
                        path.includes("create-secret") && props.history.push("/instance-list");
                        const subscription_id_new_service: subscriptionType = (
                            path.includes("monitor/service-usage") ?
                                mp_service_subscription?.find(({ subscriptionId }: user_subscription) => subscriptionId === event) || (mp_service_subscription || [])[0] :
                                subscription?.find(({ subscriptionId }: user_subscription) => subscriptionId === event) || (subscription || [])[0]
                        );
                        set_subscription_selected(subscription_id_new_service);
                        localStorage.setItem('service_subscription_selected', JSON.stringify(subscription_id_new_service));
                        cookies.set('service_subscription_id', event, get_domain());
                    }}
                    disabled={path.includes("instance-list") && subscription?.length <= 0 ? true : false}
                >
                    {(path.includes("monitor/service-usage") && Array.isArray(mp_service_subscription)) &&
                        mp_service_subscription.map(({ subscriptionId, subscriptionName, company }: user_subscription) => (
                            subscriptionId === "all" ?
                                <Option key="all" value="all">
                                    <Row >
                                        <Col xs={24} className="font-w-6">
                                            <FormattedMessage id="all_subscription" />
                                        </Col>
                                    </Row>
                                </Option> :
                                <Option key={subscriptionName + company} value={subscriptionId}>
                                    <Row
                                        title={
                                            formatMessage({ id: "subscription_name" }) +
                                            ": " +
                                            subscriptionName +
                                            "        " +
                                            formatMessage({ id: "company" }) +
                                            ": " +
                                            company
                                        }
                                    >
                                        <Col lg={9} md={10} sm={11} xs={12} className="font-w-6 text-ellipsis">
                                            {subscriptionName}
                                        </Col>
                                        <Col lg={13} md={12} sm={11} xs={10} className="ml-10 text-ellipsis">
                                            {company}
                                        </Col>
                                    </Row>
                                </Option>
                        ))}
                    {(!path.includes("monitor/service-usage") && Array.isArray(subscription)) &&
                        subscription.map(({ subscriptionId, subscriptionName, company }: user_subscription) => (
                            subscriptionId === "all" ?
                                <Option key="all" value="all">
                                    <Row >
                                        <Col xs={24} className="font-w-6">
                                            <FormattedMessage id="all_subscription" />
                                        </Col>
                                    </Row>
                                </Option> :
                                <Option key={subscriptionName + company} value={subscriptionId}>
                                    <Row
                                        title={
                                            formatMessage({ id: "subscription_name" }) +
                                            ": " +
                                            subscriptionName +
                                            "        " +
                                            formatMessage({ id: "company" }) +
                                            ": " +
                                            company
                                        }
                                    >
                                        <Col lg={9} md={10} sm={11} xs={12} className="font-w-6 text-ellipsis">
                                            {subscriptionName}
                                        </Col>
                                        <Col lg={13} md={12} sm={11} xs={10} className="ml-10 text-ellipsis">
                                            {company}
                                        </Col>
                                    </Row>
                                </Option>
                        ))}
                </Select>}

                {!service_pathname.includes(path) && user_subscriptions && !path.includes("user/") && is_not_login && <Select
                    className={`${!path.includes('console') && !path.includes('instance-list') ? 'height-40' : ''} w-100`}
                    showSearch
                    value={user_subscriptions.length > 0 ? user_info.subscription_id : ''}
                    // disabled={user_subscriptions.length < 2}
                    optionFilterProp="children"
                    dropdownRender={(menu) => (
                        <Fragment>
                            <div className="ant-select-item ant-select-item-group">With Resources Only</div>
                            {menu}
                        </Fragment>
                    )}
                    filterOption={(input, option) => (option?.key as string)?.toLocaleLowerCase().includes(input.toLocaleLowerCase())}
                    onChange={(event: string) => {
                        path.includes("create-secret") && props.history.push("/instance-list");
                        const subscription_id_new: string | undefined = (
                            user_subscriptions?.find(({ subscriptionId }: user_subscription) => subscriptionId === event) || (user_subscriptions || [])[0]
                        )?.subscriptionId;
                        if (subscription_id_new) {
                            new Cookies().set("subscription_id", subscription_id_new, {
                                domain: document.domain.substr(document.domain.indexOf(".")),
                                path: "/",
                            });
                            set_user_info((currentState) => ({ ...currentState, role: "", subscription_id: subscription_id_new }));
                        }

                    }}
                >
                    {Array.isArray(user_subscriptions) && user_subscriptions.length > 0 &&
                        user_subscriptions.map(({ subscriptionId, subscriptionName, company }: user_subscription) => (
                            <Option key={subscriptionName + company} value={subscriptionId}>
                                <Row
                                    title={
                                        formatMessage({ id: "subscription_name" }) +
                                        ": " +
                                        subscriptionName +
                                        "        " +
                                        formatMessage({ id: "company" }) +
                                        ": " +
                                        company
                                    }
                                >
                                    <Col lg={9} md={10} sm={11} xs={12} className="font-w-6 text-ellipsis">
                                        {subscriptionName}
                                    </Col>
                                    <Col lg={13} md={12} sm={11} xs={10} className="ml-10 text-ellipsis">
                                        {company}
                                    </Col>
                                </Row>
                            </Option>
                        ))}
                </Select>}
            </div>
        </Fragment>
    )
}

export default injectIntl(withRouter(DropdownMenuSubscription) as any);
